import { APPS_SCRIPT_URL, ADMIN_TOKEN } from '../config.js';

export function isConfigured() {
  return Boolean(APPS_SCRIPT_URL && ADMIN_TOKEN);
}

export async function getConfig() {
  if (!isConfigured()) {
    throw new Error('Apps Script no configurado. Define VITE_APPS_SCRIPT_URL y VITE_ADMIN_TOKEN en .env.local.');
  }
  const url = `${APPS_SCRIPT_URL}?action=config&token=${encodeURIComponent(ADMIN_TOKEN)}`;
  const res = await fetch(url, { method: 'GET' });
  if (!res.ok) throw new Error('Error HTTP ' + res.status);
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}

export async function saveConfig({ recipients, emailEnabled }) {
  if (!isConfigured()) {
    throw new Error('Apps Script no configurado. Define VITE_APPS_SCRIPT_URL y VITE_ADMIN_TOKEN en .env.local.');
  }
  const body = new URLSearchParams({
    action: 'saveConfig',
    token: ADMIN_TOKEN,
    payload: JSON.stringify({ recipients, emailEnabled }),
  });
  const res = await fetch(APPS_SCRIPT_URL, {
    method: 'POST',
    body,
  });
  if (!res.ok) throw new Error('Error HTTP ' + res.status);
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data;
}
